import { render, staticRenderFns } from "./worldBossInfoModal.vue?vue&type=template&id=106b900d&scoped=true&"
import script from "./worldBossInfoModal.vue?vue&type=script&lang=js&"
export * from "./worldBossInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./worldBossInfoModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./worldBossInfoModal.vue?vue&type=style&index=1&id=106b900d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b900d",
  null
  
)

export default component.exports